module.exports = __webpack_public_path__ + "static/img/logo.62fb454e.svg";